import { FormProvider } from 'react-hook-form';
import { styled } from '@mui/material/styles';
import { useCertificateUploadForm } from './hooks/use-certificate-upload-form';
import { CertificateFormStep } from './steps/certificate-form-step';

export const UploadCertificateForm = ({ workerId }: { workerId: string }) => {
  const { form, onSubmit } = useCertificateUploadForm(workerId);

  return (
    <FormProvider {...form}>
      <StyledForm onSubmit={form.handleSubmit(onSubmit)} noValidate>
        <CertificateFormStep />
      </StyledForm>
    </FormProvider>
  );
};

const StyledForm = styled('form')({
  width: '100%',
  display: 'flex',
  justifyContent: 'center',
});
